import React, { useEffect, useState } from 'react';
import { Button, Card, CardText, CardTitle } from 'reactstrap';
import moment from 'moment';

const DocumentAnnotations = (props) => {
    const [annotations, setAnnotations] = useState([]);

    useEffect(() => {
        getAnnotationsForDocument();
    }, [])

    const getAnnotationsForDocument = async () => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/get_document_annotiations?document_id=' + props.id)
            .then(res => res.json())
            .then(
                (result) => {
                    setAnnotations(result.annotations);
                })
            .catch(error => {
                console.error(error);
            });
    }

    const DeleteAnnotations = async (id) => {
        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/delete_annotiation?id=' + id, {
            method: "DELETE"
        })
            .then(res => res.json())
            .then(
                (result) => {
                    getAnnotationsForDocument();
                })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <>
            {annotations.map(annotate => (
                <Card
                    body
                    color="primary"
                    outline
                    style={{ marginTop: '10px', marginBottom: '10px' }}
                >
                    <CardTitle style={{ fontSize: '1rem' }}>
                        {annotate.annotation}
                    </CardTitle>
                    <CardText>
                        <p>{annotate.user}</p>
                        <p style={{ fontSize: '9px' }}>{moment(annotate.datetime).format("DD-MM-yyyy")}</p>
                    </CardText>
                    <Button
                        style={{ width: '40px', marginTop: '10px' }}
                        color="danger"
                        outline
                        className="navbtn s-fonticon-btn"
                        onClick={() => DeleteAnnotations(annotate._id)}
                    >
                        
                    </Button>
                </Card>
            ))}

        </>
    )
}

export default DocumentAnnotations;